
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageContext } from '../../Context/MessageContext';
import Axios from 'axios';
import Config from '../../Config/Config';
import { useMsal } from "@azure/msal-react";

const useSearchShiftTypes = () => {
    const rootPath = Config.api.rootPath;
    const { instance } = useMsal();
    const { t } = useTranslation();
    const { addMessage, removeMessage } = useContext(MessageContext);
    const [ shiftTypes, setShiftTypes ] = useState([]);
    const [ fetchingShiftTypes, setFetchingShiftTypes ] = useState(true);

    /** search shift types
    * @param {searchParams} object including all search parameters
    *   starttime - shifts after (and including) this date
    *   endtime - shifts before (and including) this date
    *   service - shifts having types with this service
    *   channel - shifts having types with this channel
    *   type - shifts having this type
    *   location - shifts in this location
    * @returns {array} - array of shift types 
    */ 
    const searchShiftTypes = async (searchParams) => {
        try {

            const msgId = addMessage({ type: "loading", header: t('general.moment'), body: t('info.fetchingShifts')});

            const activeAccount = instance.getActiveAccount();
            const accounts = instance.getAllAccounts();

            if (!activeAccount && accounts.length === 0) return;

            const request = {
                scopes: Config.api.scopes,
                account: activeAccount || accounts[0]
            }

            const authResult = await instance.acquireTokenSilent(request);
            
            const options = {
                "headers": {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + authResult.accessToken
                }
            }

            let result = null;

            let queryString = ""
            if (searchParams && searchParams.startdate) { queryString += "starttime=" + searchParams.startdate + '&'}
            if (searchParams && searchParams.enddate) { queryString += "endtime=" + searchParams.enddate + '&'}
            if (searchParams && searchParams.service) { queryString += "service=" + searchParams.service + '&'}
            if (searchParams && searchParams.channel) { queryString += "channel=" + searchParams.channel + '&'}
            if (searchParams && searchParams.type) { queryString += "type=" + searchParams.type + '&'}
            if (searchParams && searchParams.own) { queryString += "own=" + searchParams.own + '&'}
            if (searchParams && searchParams.locations) { queryString += "locations=" + searchParams.locations + '&'}
            if (searchParams && searchParams.sort) { queryString += "sort=" + searchParams.sort + '&'}
            if (searchParams && searchParams.order) { queryString += "order=" + searchParams.order + '&'}

            //console.log(queryString)

            result = await Axios.get(rootPath + "/api/v1/search/shifttypes?" + queryString, options);

            removeMessage(msgId);

            
            if (result && result.status === 200 && result.data) {
                setShiftTypes(result.data);
                setFetchingShiftTypes(false);
                return result;
            }

            if (result && result.status === 404) {
                addMessage({ type: "warning", header: t('general.error'), body: t('warnings.shiftsNotFound') });
                setFetchingShiftTypes(false);
                return result;
            }

            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingShiftsFailed') });
            setFetchingShiftTypes(false);
            return result;

        } catch (error) {
            if (Config.environment === 'development' || Config.environment === 'test') console.log(error);
            addMessage({ type: "error", header: t('general.error'), body: t('errors.fetchingShiftsFailed') });
            setFetchingShiftTypes(false);
            return error;
        }
    }

    return { shiftTypes, fetchingShiftTypes, searchShiftTypes };
}

export default useSearchShiftTypes;